<template>
  <div class="wrap">
    <h2>妥妥递私募基金募集机构综合服务系统网络服务协议</h2>
    <h4>重要提示</h4>
    <p>妥妥递私募基金综合服务系统（下称“系统”）系由四川妥妥递科技有限公司（下称“妥妥递”）开发运营的电子签约系统，由妥妥递私募基金托管人综合服务系统（即“托管人端”）以及妥妥递私募基金募集机构综合服务系统（即“募集机构端”，含妥私募企业版APP，即理财师APP），妥私募APP（即“投资人端”）等子系统组成。私募产品募集机构通过募集机构端向投资者提供特定对象确定、投资者适当性匹配、风险揭示、合格投资者确认、录音录像等募集流程服务和电子签约服务（以下合称“系统服务”）。</p>
    <p>本协议双方为私募产品募集机构与投资人用户，投资人用户（下称“您”）注册系统后通过募集机构的邀请码进入募集机构端时务必仔细阅读本协议，若您不同意本协议的任意内容，请不要进行后续操作。若您继续使用募集机构端的任何服务，即意味着您已充分理解本协议所有条款的含义及相应的法律后果，同意并接受本协议的约束。</p>
    <p>本协议项下“基金”或“私募基金”，指在中华人民共和国境内，以非公开方式向投资者募集资金设立的投资基金，包括在基金业协会登记的私募基金管理人募集并设立的契约型基金、合伙型基金或公司型基金，由证券公司及其子公司、期货公司及其子公司、基金管理公司及其子公司募集并设立的私募资产管理计划。本协议项下“募集机构”指前述私募产品的管理机构及销售机构。</p>
    <h4>1. 服务说明</h4>
    <p>1.1. 募集机构有权随时对本协议内容进行单方面的变更，并通过在募集机构端以包括但不限于公告等方式予以公布，无需另行单独通知您。若您在本协议内容公告变更后继续使用本系统服务，表示您已充分阅读、理解并接受修改后的协议内容，也将遵循修改后的协议内容使用本系统服务。若您不同意修改后的协议内容，您应停止使用本系统服务。</p>
    <p>1.2. 使用本系统服务，请您注册成为系统用户。自然人注册成为系统用户，应当年满18周岁并且具有法律规定的完全民事权利能力和完全民事行为能力，能够独立承担民事责任。不具备前述条件的，您应立即停止使用本系统服务。如经募集机构核实您不符合本条款要求，募集机构将有权单方面终止系统服务，且不负有任何法律责任。</p>
    <p>1.3. 请注意私募产品不承诺保本和最低收益，具有一定的投资风险，投资者的本金可能会因市场变动而蒙受损失，您应当正确认识自己的风险识别能力和风险承受能力，充分了解私募产品管理机构的投资团队、投资历史、诚信记录等相关因素，充分认识私募产品的风险收益特征和产品特性，审慎评估市场风险、信用风险、流动性风险、操作风险、政治法律风险等各类投资风险，做出与自己风险识别能力和风险承受能力相匹配的决策并自主承担责任。</p>
    <p>1.4. 本系统采用签名（章）信息图形化展现技术，您可通过签名管理功能设置并管理签名（章）图片。该图片单独使用或者打印后使用不构成您确认和同意文件内容的意思表示。您在本系统使用数字证书进行数字签名，是您确认和认可签名文件的真实意思表示，无论签名（章）图片所载内容为何，无论签名（章）图片显示位置为何。</p>
    <p>1.5. 您注册成为系统用户，使用本系统服务，即代表您自愿采用电子签名方式签署私募基金合同及相关文件，同意电子签名是您确认和认可签名文件的真实意思表示，同意即使签名文件中约定采用纸质合同方式签署，该签名文件仍然对您具有法律约束力。</p>
    <h4>2. 实名认证与数字证书</h4>
    <p>2.1. 您同意募集机构通过募集机构端对您进行实名认证，储存并使用向您收集的身份信息（包含但不限于募集机构当面向您收集或通过互联网方式向您收集的能验证您真实身份的信息资料）用于向第三方电子认证服务机构（CFCA）申领数字证书，从而完成私募基金合同及相关文件的电子签署。</p>
    <p>2.2. 因您使用募集机构端是为线上预约、签订拟购买私募产品合同之目的，您应当使用真实的信息资料进行身份验证，并为所提供资料的真实性、合法性负责。若因您故意或过失提供不真实的信息资料导致数字证书签发错误，因而造成损失的，由您自行承担一切法律责任。</p>
    <p>2.3. 您同意授权四川妥妥递科技有限公司代理您向中金金融认证中心有限公司（以下称“CFCA“）依据其电子认证业务规则申领数字证书，您申领和使用数字证书，应当遵守CFCA的电子认证业务规则(CPS)、证书策略和数字证书服务协议(详见https://www.cfca.com.cn/)。因数字证书服务产生的纠纷，需要您与CFCA解决。</p>
    <h4>3. 使用规则</h4>
    <p>3.1. 募集机构端向您提供实名认证、特定对象确认、合格投资者确认、风险承受能力测评、适当性匹配、在线签约、录音录像、数据传递、数据存储等与此相关的电子签约服务。募集机构为向您提供前述服务，可能需要了解并获取您的基本信息、财务状况、投资知识、投资经验、风险偏好等。请您按照系统操作流程规范操作，诚实信用。</p>
    <p>3.2. 您在系统内向第三方电子认证服务机构（CFCA）申领的数字证书只能用于系统服务相关的身份标识、电子签约、加密数据，不能作为其它任何用途，若您将数字证书用于其他用途，由您自行承担相关责任。</p>
    <p>3.3. 您应当妥善保管您在系统内申领的数字证书、私钥及您自行设置的保护密码，不得泄露或交付给他人保管及使用。如因故意、过失导致他人知道或遭盗用、冒用、伪造或者篡改时，后果应当由您自行承担。如遇遗失或被窃，应当立即向妥妥递及募集机构办理挂失或注销，并配合提供相关资料以便完成数字证书的恢复使用或重新发放。</p>
    <p>3.4. 数字证书一律不得转让、转借或转用。因转让、转借或转用而产生的一切损失均由您自行负责。若您用于申领数字证书所提供的信息发生变动，应立即通知募集机构及妥妥递。因您信息发生变化而未及时通知妥妥递及募集机构更新证书信息造成的不良后果由您自行承担。</p>
    <p>3.5. 您确认您代表企业在募集机构端上签署文件的情况下，您向募集机构提供的必要的签署信息（包括但不限于企业身份证明材料、印章等）已经获得该企业的合法授权，您应确保上述信息完整、真实、有效、准确、最新。您应对因您未能遵守本款约定而发生的任何损失、损毁及其他不利后果负责。</p>
    <p>3.6. 您认可本系统采用的电子签署策略，并认可该策略下可靠的在线身份认证手段及系统内权威第三方电子认证服务机构（CFCA）向您签发的数字证书，用该数字证书进行的电子签名即为您认可的可靠电子签名。</p>
    <p>3.7. 您知悉并同意在您使用数字证书进行签字（签章）的同时使用本系统服务提供的时间戳为您电子合同的签署时间。</p>
    <p>3.8. 为确保您在募集机构端签署的电子合同为您本人的意愿，您同意并授权对您签署合同前的风险揭示进行录音录像并进行加密存储。</p>
    <p>3.9. 请您妥善保管您的手机号、邮箱账号和密码、银行卡账号及密码、服务中与身份验证等相关的其他账号和密码，所有基于前述的一切指令及产生的行为均将视为您本人的行为，其行为后果由您本人承担。如果这类工具被盗或被冒用而产生损失，由您自行负责。</p>
    <p>3.10. 您保证您履行募集机构端上签订的合同时，支付的资金来源合法。</p>
    <p>3.11. 您对通过系统提供的所有信息的真实性、准确性、即时性、完整性和合法性独立承担所有责任。同时，在您所发布的信息中不得含有蓄意毁坏、恶意干扰、秘密地截取或侵占任何系统、数据或个人资料的任何病毒、伪装破坏程序、电脑蠕虫、定时程序炸弹或其他电脑程序。</p>
    <h4>4. 通知及送达</h4>
    <p>4.1. 通知方式。您同意募集机构使用电子方式通知您。电子方式包括但不限于以电子邮件方式、募集机构端公告等方式。</p>
    <p>4.2. 送达。系统的通知如以公示方式做出，一经募集机构端公示即视为已经送达。除此之外，其他向您个人发布的具有专属性的通知将通过您提供的电子邮箱或绑定的手机号码发送，一经发送即视为已经送达。请您密切关注您的电子邮箱以及手机中的短信信息。因信息传输等原因导致您未在前述通知发出当日收到该等通知的，由您自行负责。</p>
    <p>4.3. 通知内容。您同意募集机构通过您提供的联系方式及募集机构端向您传递相关的信息，包括但不限于系统管理方面的通知、私募产品信息、有关您使用募集机构端的通讯以及针对性的广告条等。</p>
    <h4>5. 违约责任</h4>
    <p>5.1. 因您违反本协议或经在此提及而纳入本协议的其他文件，或因您违反了法律、法规、规章、政府规范性文件或侵害了第三方的权利，而使第三方对募集机构、妥妥递提出索赔要求，您必须对此赔偿要求承担赔偿责任，使募集机构及妥妥递等免遭损失。</p>
    <p>5.2. 如因募集机构违反有关法律、法规或本协议项下的任何条款而给您造成损失，募集机构同意承担由此造成的损害赔偿责任。</p>
    <p>5.3. 其他责任遵循过错责任原则进行处理。</p>
    <h4>6. 法律适用及管辖</h4>
    <p>6.1. 本协议的订立、变更、执行和解释，以及与本协议有关的争议解决，均应适用中华人民共和国法律。</p>
    <p>6.2. 因本协议或募集机构端服务所引起或与其有关的任何争议应向四川妥妥递科技有限公司所在地人民法院起诉。</p>
    <h4>7. 其他</h4>
    <p>7.1. 本协议自您首次以勾选、点选或点击确定等任意形式同意之时起生效。</p>
    <p>7.2. 本协议部分条款被认定为无效时，不影响本协议其他条款的效力。</p>
    <p>7.3. 本协议中的标题仅为方便而设，在解释本协议时应被忽略。</p>
  </div>
</template>
<style lang="css">
.vux-check-icon > .weui-icon-success:before,
.vux-check-icon > .weui-icon-success-circle:before {
  color: #3d82f7 !important;
}
</style>
<script>

export default {
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>
<style lang="sass" scoped>
@import "~./document.scss";
</style>
